var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPause = function SvgPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10 20a10 10 0 1 1 10-10 10.01 10.01 0 0 1-10 10m0-18.333A8.333 8.333 0 1 0 18.333 10 8.34 8.34 0 0 0 10 1.667"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.333 14.16a.833.833 0 0 1-.833-.832V6.682a.833.833 0 0 1 1.667 0v6.646a.833.833 0 0 1-.834.833M11.665 14.16a.833.833 0 0 1-.833-.832V6.682a.833.833 0 1 1 1.667 0v6.646a.833.833 0 0 1-.834.833"
  })));
};
export default SvgPause;